import React, {Component} from 'react';
import {connect} from "react-redux";
import Discount from "./discount";
import DiscountAdd from "./discountAdd";
import DiscountSubTotal from "./discountSubTotal";
import {sortByOrder} from "../../misc/helpers";

class PriceWorksheetList extends Component {

  render() {
    // const fabricatorSettings = this.props.fabricatorData.settings;
    const discountSections = sortByOrder(this.props.discountSections);
    return (
      <div className="discounts">
        {discountSections.map((discountSection, discountSectionIndex) => {
          const discounts = sortByOrder(discountSection.discounts).filter((disc) => !disc.oldDeleted);
          return (
            <div key={discountSectionIndex} className={"discounts-section"}>
              <h3 className="scart-block__title">{discountSection.name}</h3>
              <ul className="discounts-list">
                {discounts.map((discount, discountIndex) => {
                  switch (true) {
                    case discount.isRidged:
                      return <DiscountAdd key={discountIndex}
                                           discount={discount}
                                           discountSection={discountSection}/>
                    case discount.isSubTotal:
                      return <DiscountSubTotal key={discountIndex}
                                               discount={discount}
                                               discountSection={discountSection}/>
                    default:
                      return <Discount key={discountIndex}
                                       discount={discount}
                                       discountSection={discountSection}/>
                  }
                })}
              </ul>
            </div>
          )
        })}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    discountSections: store.priceWorksheetState.discountSections,
    fabricatorData: store.fabricatorState,
  };
};

export default connect(mapStateToProps, {

})(PriceWorksheetList);
